module.exports = __webpack_public_path__ + "static/media/atom.0efa25c7.svg";